/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useEffect, useRef, useState } from "react";
import { API } from "../../../globals/globals";
import { useExportEventsMutation, useGetEventsQuery } from "../../../store/api/devices/deviceApiSlice";
import { urlParameterSelector } from "../../../store/filters/events/EventFilterSelectors";
import { useSelector } from "react-redux";
import { eventsColumns } from "../../../components/Shared/Table/Columns";
// import { useLocation } from "react-router-dom";
import { searchKeywordByScopeSelector, searchKeywordSelector } from "../../../store/search/selector";
import { setDeviceCount, setOpenToast } from "../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../store/hooks";
import { paginationModelSelector, selectedNavListItemSelector } from "../../../store/helpers/helperSelectors";
import { errorMessage, exportInCSV } from "../../../utils/helpers";
// import { deviceSiteGroupSelector } from "../../../store/filters/Nodes/selectors";
import { initialState } from "../../../store/helpers/helperInitialState";
// import { selectedGeoRegionSelector } from "../../../store/filters/Nodes/selectors";

export const useEventDisplay = (selectedGeoRegions?: string[]) => {
//  const geoRegion = useSelector(selectedGeoRegionSelector);
  const dispatch = useStoreDispatch();
//  const location = useLocation();

//  const locationPath = location?.pathname.split("/");
  const filters = useSelector((state: any) => urlParameterSelector(state, selectedGeoRegions));
  const keyword = useSelector(searchKeywordByScopeSelector("events"));

  //filter events based on the selected group
  const selectedGroupKey = useSelector(selectedNavListItemSelector);
//  const selectedGroupKeyValue = useSelector(deviceSiteGroupSelector);

  const { eventDisplay = initialState.pagination } = useSelector(paginationModelSelector);
  const [exportEvents, exportStatus] = useExportEventsMutation();
  const [sortOrder, setSortOrderToEvent] = useState("retention,desc");
  const [applyingFilter, setApplyingFilter] = useState(false);
  const [applyingPagination, setApplyingPagination] = useState(false);

  filters.set("sort", sortOrder);
  filters.set("page", eventDisplay.page.toString());
  filters.set("size", eventDisplay.pageSize.toString());
  filters.set("search", keyword);
  filters.has("isAlarm") && filters.delete("isAlarm");

  switch (selectedGroupKey) {
    case "devices": {
      filters.set("deviceSpecs", "");
      break;
    }
    case "disconnected": {
      filters.set("deviceSpecs", "");
      break;
    }
    case "maintenancemode": {
      filters.set("deviceSpecs", "");
      break;
    }
    case "pmCollected": {
      filters.set("deviceSpecs", "");
      break;
    }

    case "ungrouped": {
      // filters.set("deviceSpecs", "parentKey,''");
      break;
    }

    default: {
      if (!!selectedGroupKey) {
        filters.set("deviceSpecs", "");
        // filters.set("deviceSpecs", `parentKey,${selectedGroupKeyValue}`);
      }
      break;
    }
  }

  let args:any;
  // if (locationPath.includes("device")) {
  //   args = { filters: filters.toString(), deviceKey: locationPath[2] };
  // } else {
  args = { filters: filters.toString() };
  // }
  const { data, isLoading, isFetching, refetch } = useGetEventsQuery(args, {
    pollingInterval: API.ENDPOINTS.EVENTS.pollingInterval || API.POLLING_INTERVAL,
  });

  const hasMounted = useRef(false); // Ref to track initial load
  useEffect(() => {
    if (hasMounted.current) {
      refetch();
      console.log("Filters or search term changed");
      setApplyingFilter(true);
    }
  }, [keyword, filters.toString(), refetch]);

  useEffect(() => {
    if (hasMounted.current) {
      console.log("Pagination changed");
      setApplyingPagination(true);
    }
  }, [eventDisplay])

  useEffect(() => {
    if (!isFetching) {
      console.log("Fetch completed");
      setApplyingFilter(false);
      setApplyingPagination(false);
    }
  }, [isFetching]);

  useEffect(() => {
    hasMounted.current = true;
  }, []);

  useEffect(() => {
    dispatch(
      setDeviceCount({
        disconnectedDeviceCount: Number(localStorage.getItem("disconnected")),
        allDeviceCount: Number(localStorage.getItem("allDevice")),
        inMaintenanceModeCount: Number(localStorage.getItem("inMaintenanceMode")),
        ungroupedCount: Number(localStorage.getItem("ungrouped")),
        kpiSyncErrorCount: Number(localStorage.getItem("kpiErorrCount")),
        offLineDeviceCount: Number(localStorage.getItem("offLineDeviceCount")),
        configMismatchCount: Number(localStorage.getItem("configMismatchCount")),
      })
    );
  }, [dispatch]);

  const exportHandler = async () => {
    try {
      const response: any = await exportEvents(args);

      if (response?.error) throw response?.error;
      exportInCSV(response, "Events");
    } catch (error: any) {
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
    }
  };

  return {
    data,
    isLoading,
    isFetching,
    applyingFilter,
    applyingPagination,
    eventsColumns,
    exportHandler,
    exportStatus,
    setSortOrderToEvent,
  };
};
